import React, { useState, useEffect } from 'react';
import { useCart } from '../../context/CartContext';
import { toast } from 'react-toastify';
import QuantityInput from '../QuantityInput/QuantityInput';
import api from '../../services/api';
import './AddToCartModal.css';

const AddToCartModal = ({ barang, onClose }) => {
    const [quantity, setQuantity] = useState(1);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const { addToCart } = useCart();
    const API_URL = api.defaults.baseURL.replace('/api', '');

    useEffect(() => {
        if (barang && barang.Products && barang.Products.length > 0) {
            setSelectedVariant(barang.Products[0]);
        }
        setQuantity(1);
    }, [barang]);

    if (!barang) return null;

    const handleAddToCart = () => {
        if (!selectedVariant) return;
        addToCart(selectedVariant.id, quantity);
        toast.success(`${quantity} x ${barang.nama_barang} (${selectedVariant.nama_satuan}) ditambahkan!`);
        onClose();
    };

    const handleVariantChange = (e) => {
        const variantId = e.target.value;
        const variant = barang.Products.find(v => v.id.toString() === variantId.toString());
        setSelectedVariant(variant);
    };

    const totalPrice = (selectedVariant?.price || 0) * quantity;

    return (
        <div className="modal-overlay-bottom" onClick={onClose}>
            <div className="add-to-cart-modal" onClick={(e) => e.stopPropagation()}>

                <div className="modal-header">
                    <h4>{barang.nama_barang}</h4>
                    <button className="modal-close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>

                <div className="modal-product-info">
                    <div className="modal-product-image-placeholder">
                        {/* === PERUBAHAN DI SINI === */}
                        {barang.BarangImages && barang.BarangImages.length > 0 ?
                            <img src={`${API_URL}/${barang.BarangImages[0].imageUrl}`} alt={barang.nama_barang} className="modal-product-image" /> :
                            <span>?</span>
                        }
                        {/* === AKHIR PERUBAHAN === */}
                    </div>
                    <div className="modal-product-details">
                        <p>Rp {new Intl.NumberFormat('id-ID').format(selectedVariant?.price || 0)}</p>
                    </div>
                </div>

                <div className="modal-variant-selector">
                    <label>Pilih Satuan</label>
                    <select onChange={handleVariantChange} value={selectedVariant?.id || ''}>
                        {barang.Products.map(v => (
                            <option key={v.id} value={v.id}>{v.nama_satuan}</option>
                        ))}
                    </select>
                </div>

                <div className="modal-quantity-selector">
                    <p>Jumlah</p>
                    <QuantityInput
                        quantity={quantity}
                        onChange={setQuantity}
                        maxStock={selectedVariant?.stock || 999}
                    />
                </div>

                <button onClick={handleAddToCart} className="modal-add-button" disabled={!selectedVariant}>
                    <span>+ Keranjang</span>
                    <span>Rp {new Intl.NumberFormat('id-ID').format(totalPrice)}</span>
                </button>
            </div>
        </div>
    );
};

export default AddToCartModal;